import React from 'react'

export default class PrevNext extends React.Component {
  render() {
    return (
      <div className="prev-next">
        <div className="prev" onClick={this.props.clickPrev}>
          <i className="fa fa-angle-left" />
        </div>
        <div className="next" onClick={this.props.clickNext}>
          <i className="fa fa-angle-right" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/prev-next.js